import {
  User,
  InvestmentFunds,
  InvestmentGroups,
} from './master-visualizar-usuario.model';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MasterVisualizarUsuarioService } from './master-visualizar-usuario.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { EditUserComponent } from '../edit-user/edit-user.component';
import { UserStatus } from '@app/shared/models/user-status';
import { AppScreenBase } from '@app/custom-shared/util/app-screen-base';
import { take } from 'rxjs/operators';
import { CryptoService } from '@app/core/services/crypto/crypto.service';

@Component({
  selector: 'app-master-visualizar-usuario',
  templateUrl: './master-visualizar-usuario.component.html',
  styleUrls: ['./master-visualizar-usuario.scss'],
})
export class MasterVisualizarUsuarioComponent extends AppScreenBase
  implements OnInit {
  protected onClose(): void {}

  id: any;
  user: User;
  dialogConfig: any;
  fundsColumns = ['code', 'name'];

  @ViewChildren(MatSort) sortFunds = new QueryList<MatSort>();

  panelOpenState = false;

  constructor(
    private userService: MasterVisualizarUsuarioService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<MasterVisualizarUsuarioComponent>,
    private cryptoService: CryptoService,
  ) {
    super();
  }

  ngOnInit() {
    this.getUser();

    this.dialogConfig = new MatDialogConfig();

    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.hasBackdrop = true;
    this.dialogConfig.height = '90vh';
    this.dialogConfig.width = '92vw';
    this.dialogConfig.maxWidth = '100vw';
  }

  get userInactive(): boolean {
    if (!this.user) return true;
    return (
      this.user.status &&
      this.user.status.toLowerCase() == UserStatus.inativo.toLowerCase()
    );
  }

  getUser() {
    this.userService.getUserByUserId(this.id).subscribe(response => {
      this.user = response;
      this.user.investmentGroups = response.investmentGroups.naturalSort([
        'name',
      ]);

      if (this.user.nationality) {
        if (this.user.nationality.toLowerCase() == 'residente') {
          this.user.documentNumber = this.user.documentNumber.replace(
            /(\d{3})(\d{3})(\d{3})(\d{2})/g,
            '$1.$2.$3-$4',
          );
        }
      }
      if (this.user.internationalPrefix) {
        this.user.internationalPrefix = this.user.internationalPrefix.substr(
          2,
          3,
        );
      }
      if (this.user.cellNumber) {
        this.user.cellNumber = this.user.cellNumber.replace(
          /(\d{2})(\d{5})(\d{4})/g,
          '($1)$2-$3',
        );
      }
    });
  }

  instanceDataSource(arr, index) {
    const dataSource = new MatTableDataSource<InvestmentFunds>(
      arr.naturalSort(['code']),
    );

    dataSource.sortingDataAccessor = (data, sortHeaderId) =>
      data[sortHeaderId].naturalNormalize();
    dataSource.sort = this.sortFunds.toArray()[index];
    return dataSource;
  }

  doFechar() {
    this.dialogRef.close();
  }

  editUser() {
    if (this.userInactive) return;
    this.dialogConfig.data = { id: this.id };
    let editDialog: MatDialogRef<any>;
    editDialog = this.dialog.open(EditUserComponent, this.dialogConfig);

    editDialog
      .afterClosed()
      .pipe(take(1))
      .subscribe(result => {
        this.getUser();
        this.dialogConfig.data = null;
      });
  }
}
